import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CloudinaryImageService extends ServiceBase {

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public uploadImage(formData: FormData): Observable<string> {
    const httpOptions = {
      headers: new HttpHeaders({
        'enctype': 'multipart/form-data',
        'Accept': 'application/json'
      })
    };
    const api: string = '/Upload';
    const method: string = '/single';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<string>(url, formData, httpOptions);
  }

 
  public uploadIFile(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('ImageFile', file); // Note: Using 'ImageFile' as the field name
    
    const httpOptions = {
      headers: new HttpHeaders({
        // Don't set Content-Type - let browser set it with boundary
        'Accept': 'application/json'
      }),
      withCredentials: true
    };

    const api: string = '/Upload';
    const method: string = '/file';
    const url: string = environment.BASE_API_PATH + api + method;
    
    return this.http.post<string>(url, formData, httpOptions);
  }


  public uploadImages(formData: FormData): Observable<string[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      })
    };

    const api: string = '/upload';
    const method: string = '/multi';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<string[]>(url, formData, httpOptions);
  }
}